import * as React from "react";
import FilledInput from "modules/common/components/forms/inputs/filledInput";

const TopicLimitedTextField: React.FunctionComponent<ComponentProps> = (props : ComponentProps) => {

    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => 
        props.onChange(event.target.value as string);

    return (
        <React.Fragment>
            <FilledInput
                value={props.value}
                label={""}
                characterCount
                maxCount={100}
                variant="outlined"
                errorHelperText={props.errorText}
                inputProps={{
                    style: {
                        fontSize: '1rem'
                    },
                    onChange: handleTextChange
                }}
            />
        </React.Fragment>
    );
};

interface ComponentProps {
    value: string;
    maxLength: number;
    onChange: (newValue: string) => void;
    errorText?: string;
}

export default TopicLimitedTextField;